import { selectGtoState, useDispatch, gerenciaTecnicaSlice } from "../../../../stateManagement/redux"
import ButtonBig, { ButtonWs } from "../../../../shared/components/button_big"
import { useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { uploadConsolidatedActivities } from '../../../../stateManagement/redux/slices/gerencia_tecnica/asyncReducers'
import { RoutesWeb } from "../../../../shared/interfaces/routes";
import { CustomInput } from "../../../../shared/components/customInput";
import { getSummary, MessageSummary } from "src/tecnica/utils/getSummary";

export type TamUploadFailure = { fileName: string; reason: string };

export type TamUploadResult = {
    ok: number;
    failed: TamUploadFailure[];
    duplicated?: number;
};

export const UploadActivitiesModal = ({
    close,
    sortActivities,
    executedDate,
    onActivitiesUploaded,
    tamReadyCount = 0,
    initialStep = 'CheckWsMessage',
    canUpload = true,
    blockingMessages = [],
    isValidating = false,
}: {
    close: any;
    sortActivities: any[];
    executedDate: any;
    onActivitiesUploaded?: () => Promise<TamUploadResult | null>;
    tamReadyCount?: number;
    initialStep?: string;
    canUpload?: boolean;
    blockingMessages?: string[];
    isValidating?: boolean;
}) => {

    const mainState = useSelector(selectGtoState);
    const navigate = useNavigate();

    useEffect(() => {
        console.log('[UploadActivitiesModal] montado', {
            initialStep,
            canUpload,
            isValidating,
            sortActivities: sortActivities.length,
            blockingMessages: blockingMessages.length,
            reduxStep: mainState.uploadingStep,
        });
    }, [initialStep, canUpload, isValidating, sortActivities.length, blockingMessages.length, mainState.uploadingStep]);

    const [icon, setIcon] = useState('/assets/gifs/uploading.gif')

    const dispatch = useDispatch();

    const [showClose, setShowClose] = useState(false)

    const [messageSummary, setMessageSummary] = useState<MessageSummary>()

    const [validateNE001, setvalidateNE001] = useState(false)

    const [uploadingStep, setuploadingStep] = useState("")

    const [wsMessage, setWsMessage] = useState("")

    const [tamStatusMessage, setTamStatusMessage] = useState<string | null>(null)
    const [tamFailures, setTamFailures] = useState<TamUploadFailure[]>([])

    const [localStep, setLocalStep] = useState(initialStep)

    const tamUploadTriggeredRef = useRef(false)

    const continueWithNE001 = () => {
        dispatch(gerenciaTecnicaSlice.actions.setUploadingStep("CheckWsMessage"))
        setLocalStep('CheckWsMessage')
    }

    const startUpload = () => {
        dispatch(uploadConsolidatedActivities(sortActivities, executedDate))
    }

    useEffect(() => {
        setLocalStep(initialStep)
        dispatch(gerenciaTecnicaSlice.actions.setUploadingStep(initialStep))
        tamUploadTriggeredRef.current = false
        setTamStatusMessage(null)
        setTamFailures([])
    }, [initialStep, dispatch])

    useEffect(() => {
        const progressSteps = ['Creating Task', 'Uploading', 'Task Uploaded', 'Error Uploading'];
        if (mainState.uploadingStep && progressSteps.includes(mainState.uploadingStep)) {
            setLocalStep(mainState.uploadingStep);
        }
    }, [mainState.uploadingStep]);

    useEffect(() => {

        let stepMessage = ''

        switch (localStep) {
            case 'Error Uploading':
                setIcon('/assets/icons/error.svg')
                setShowClose(true)
                stepMessage = 'Error Uploading'
                break;

            case 'Task Uploaded':
                setIcon('/assets/gifs/uploading.gif')
                setShowClose(false)
                stepMessage = tamReadyCount > 0 ? 'Actividades cargadas. Subiendo TAM…' : 'Task Uploaded'
                break;

            case 'Validate NE001':
                setIcon('/assets/icons/warnings.svg')
                setShowClose(true)
                setvalidateNE001(true)
                stepMessage = 'Por lo menos un usuario no se encuentra registrado y sera registrado como invitado, por lo cual no le contara la actividad en el desempeño, desea continuar ?'
                break;

            case 'CheckWsMessage':
                setvalidateNE001(false)
                setShowClose(true)
                stepMessage = 'CheckWsMessage'
                break;

            default:
                setIcon('/assets/gifs/uploading.gif')
                setShowClose(true)
                stepMessage = 'Uploading'
                break;
        }

        setuploadingStep(stepMessage)

        if (sortActivities.length) {
            getSummary(sortActivities, setMessageSummary, executedDate, setWsMessage)
        }

    }, [localStep, sortActivities, executedDate, tamReadyCount])

    useEffect(() => {
        if (localStep !== 'Task Uploaded') return
        if (tamUploadTriggeredRef.current) return
        if (!onActivitiesUploaded || tamReadyCount <= 0) {
            if (tamReadyCount <= 0) {
                setIcon('/assets/icons/ok.svg')
                setShowClose(true)
                setuploadingStep('Carga completada')
            }
            return
        }

        tamUploadTriggeredRef.current = true

        void (async () => {
            try {
                const result = await onActivitiesUploaded()
                if (!result) {
                    setIcon('/assets/icons/ok.svg')
                    setShowClose(true)
                    setuploadingStep('Carga completada')
                    return
                }
                const duplicated = result.duplicated ?? 0
                if (result.failed.length) {
                    setIcon('/assets/icons/warnings.svg')
                    setTamFailures(result.failed)
                    const summaryParts: string[] = []
                    if (result.ok > 0) summaryParts.push(`${result.ok} TAM subido(s)`)
                    if (duplicated > 0) summaryParts.push(`${duplicated} ya existía(n)`)
                    summaryParts.push(`${result.failed.length} con error`)
                    setTamStatusMessage(
                        `Actividades cargadas. TAM: ${summaryParts.join(' · ')}.`,
                    )
                    setuploadingStep('Actividades cargadas · revisar TAM')
                } else if (result.ok === 0 && duplicated > 0) {
                    setIcon('/assets/icons/warnings.svg')
                    setTamFailures([])
                    setTamStatusMessage(
                        `No se subió: ${duplicated} archivo(s) TAM ya existía(n) (mismo Grupo, fecha y nombre).`,
                    )
                    setuploadingStep('Actividades cargadas')
                } else {
                    setIcon('/assets/icons/ok.svg')
                    setTamFailures([])
                    const parts = [`${result.ok} archivo(s) TAM subido(s) correctamente`]
                    if (duplicated) parts.push(`${duplicated} ya existía(n) y no se duplicó(aron)`)
                    setTamStatusMessage(parts.join(' · '))
                    setuploadingStep('Carga completada')
                }
                setShowClose(true)
            } catch {
                setIcon('/assets/icons/error.svg')
                setTamFailures([])
                setTamStatusMessage('Error al subir archivos TAM')
                setShowClose(true)
                setuploadingStep('Error Uploading')
            }
        })()
    }, [localStep, onActivitiesUploaded, tamReadyCount])

    const sendWsMessage = () => {
        const phoneNumber = '584246870497';
        if (wsMessage !== "") {
            const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(wsMessage)}`;
            window.open(url, '_blank');
        }
    }


    if (localStep === 'CheckWsMessage') {
        return (
            <div className='uploading_loader_container' >
                <div className='uploading_loader_container_input_container uploading_loader_container_input_container--wide'>
                    {isValidating && (
                        <div className="uploading_loader_container_validating">
                            Validando actividades…
                        </div>
                    )}
                    {!isValidating && !canUpload && (
                        <div className="uploading_loader_container_blockers">
                            <strong>No se puede cargar todavía. Corrige lo siguiente:</strong>
                            <ul>
                                {blockingMessages.length > 0 ? (
                                    blockingMessages.map((message) => (
                                        <li key={message}>{message}</li>
                                    ))
                                ) : (
                                    <li>Completa Generalidades (campo, fecha, cuadrilla) y revisa la pestaña Errores.</li>
                                )}
                            </ul>
                        </div>
                    )}
                    {!isValidating && canUpload && (
                        <>
                            <div>Favor validar el resumen de la cuadrilla <span className="consolidate_files_container_table_row_warning">{messageSummary?.integrantes}</span> antes de subirlas</div>
                            {tamReadyCount > 0 && (
                                <div className="uploading_loader_container_tam_hint">
                                    Tras cargar las actividades se subirán {tamReadyCount} archivo(s) TAM asociados.
                                </div>
                            )}
                            <div className="ws_message_container">
                                <CustomInput label={"Cuadrilla"} value={messageSummary?.cuadrilla || ""} onChange={() => { }} disabled={true} />
                                <CustomInput label={"Pozos visitados"} value={messageSummary?.pozos_visitados || ""} onChange={() => { }} disabled={true} />
                                <CustomInput label={"Pozos aportando"} value={messageSummary?.pozos_aportando || ""} onChange={() => { }} disabled={true} />
                                <CustomInput label={"Pozos sin aporte"} value={messageSummary?.pozos_sin_aporte || ""} onChange={() => { }} disabled={true} />
                                <CustomInput label={"Pozos operando"} value={messageSummary?.pozos_operando || ""} onChange={() => { }} disabled={true} />
                                <CustomInput label={"Pozos IT"} value={messageSummary?.pozos_IT || ""} onChange={() => { }} disabled={true} />
                                <CustomInput label={"Pozos sin acceso"} value={messageSummary?.pozos_sin_acceso || ""} onChange={() => { }} disabled={true} />
                                <CustomInput label={"Pozos recolocado"} value={messageSummary?.pozos_recolocado || ""} onChange={() => { }} disabled={true} />
                                <CustomInput label={"Pozos en observacion"} value={messageSummary?.pozos_en_observacion || ""} onChange={() => { }} disabled={true} />
                                <CustomInput label={"Pozos reespaceados"} value={messageSummary?.pozos_reespaceados || ""} onChange={() => { }} disabled={true} />
                                <CustomInput label={"Pozo sin produccion"} value={messageSummary?.pozos_sin_produccion || ""} onChange={() => { }} disabled={true} />
                                <CustomInput label={"Pozos restaurados"} value={messageSummary?.pozos_restaurados || ""} onChange={() => { }} disabled={true} />
                                <CustomInput label={"Producción asociada"} value={messageSummary?.produccion_monitoreado || ""} onChange={() => { }} disabled={true} />
                                <CustomInput label={"Producción diferida"} value={messageSummary?.produccion_diferida || ""} onChange={() => { }} disabled={true} />
                                <CustomInput label={"Producción restaurada"} value={messageSummary?.produccion_restaurada || ""} onChange={() => { }} disabled={true} />
                                <CustomInput label={"Cartas realizadas"} value={messageSummary?.cartas_realizadas || ""} onChange={() => { }} disabled={true} />
                                <CustomInput label={"Estudios Echometer"} value={messageSummary?.estudios_echometer || ""} onChange={() => { }} disabled={true} />
                                <CustomInput label={"Muestras"} value={messageSummary?.muestras || ""} onChange={() => { }} disabled={true} />
                            </div>
                        </>
                    )}
                    <div className='Upload_files_container_upload_modal_container_button_container' >
                        <ButtonBig text='Cerrar' onClick={close} />
                        {!isValidating && canUpload && uploadingStep !== 'Task Uploaded' && (
                            <ButtonBig text='Continuar' onClick={startUpload} />
                        )}
                        {!isValidating && canUpload && (
                            <ButtonWs text='Mensaje de WS' onClick={sendWsMessage} iconHeight={20} iconWidth={20} />
                        )}
                    </div>
                </div>
            </div>
        )

    }


    const isUploadFinished =
        uploadingStep === 'Task Uploaded' ||
        uploadingStep === 'Carga completada' ||
        uploadingStep === 'Actividades cargadas' ||
        uploadingStep === 'Actividades cargadas · revisar TAM'

    return (
        <div className='uploading_loader_container' >
            <div className={`uploading_loader_container_input_container${tamFailures.length ? ' uploading_loader_container_input_container--wide' : ''}`} >
                <img src={icon} width={130} height={130} alt='' />
                <div className="message_zone">{uploadingStep}</div>
                {tamStatusMessage && (
                    <div className="uploading_loader_container_tam_summary">
                        {tamStatusMessage}
                    </div>
                )}
                {tamFailures.length > 0 && (
                    <div className="uploading_loader_container_tam_errors">
                        <strong>Detalle del error TAM</strong>
                        <ul>
                            {tamFailures.map((failure) => (
                                <li key={`${failure.fileName}-${failure.reason}`}>
                                    <span className="uploading_loader_container_tam_errors_file">
                                        {failure.fileName}
                                    </span>
                                    <span className="uploading_loader_container_tam_errors_reason">
                                        {failure.reason}
                                    </span>
                                </li>
                            ))}
                        </ul>
                        <p className="uploading_loader_container_tam_errors_hint">
                            Revisá la pestaña TAM y la asignación de pozos, luego volvé a consolidar.
                        </p>
                    </div>
                )}
                {
                    showClose &&
                    <div className='Upload_files_container_upload_modal_container_button_container' >
                        <ButtonBig text='Cerrar' onClick={close} />
                        {!isUploadFinished && validateNE001 && (
                            <ButtonBig text='Continuar' onClick={continueWithNE001} />
                        )}
                        {isUploadFinished && (
                            <ButtonBig
                                text='ir al historial'
                                onClick={() => navigate(RoutesWeb.gerencia_tecnica_operaciones.history)}
                            />
                        )}
                    </div>
                }
            </div>
        </div>
    )
}
